import { TipoReportes } from "../modelo/TiposReporte";

export const DESCARGAR_REPORTE_XLS = "DESCARGAR_REPORTE_XLS";
export const EXITO_DESCARGAR_REPORTE_XLS = "EXITO_DESCARGAR_REPORTE_XLS";
export const ERROR_DESCARGAR_REPORTE_XLS = "ERROR_DESCARGAR_REPORTE_XLS";

export const descargarReporteXLS = (tipo: TipoReportes) => ({ type: DESCARGAR_REPORTE_XLS, tipo});
export const exitoDescargarReporteXLS = () => ({ type: EXITO_DESCARGAR_REPORTE_XLS});
export const errorDescargarReporteXLS = () => ({ type: ERROR_DESCARGAR_REPORTE_XLS});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/descarga_reporte/modulos/descargaReporteActions.ts